import { render } from "./openBid.vue?vue&type=template&id=d8f701a6"
import script from "./openBid.vue?vue&type=script&lang=js"
export * from "./openBid.vue?vue&type=script&lang=js"

import "./openBid.vue?vue&type=style&index=0&id=d8f701a6&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__